import React, { useCallback } from 'react';
import { DataCategorieIntervenantEXTPersonne } from '../../data/DataCategorieIntervenantEXTPersonne';
import { EUIComboBox } from '../EUI/EUIComboBox';

const ComboBoxCategorieIntervenantEXTPersonne = (props) => {

    // PROPS
    const {
        label = "Catégorie",
        placeholder = "Catégorie",
        stamp = [],
    } = props;

    // METHODS
    const _fetchMethod = useCallback(() => {
        return DataCategorieIntervenantEXTPersonne._lister();
    }, []);

    // RENDER
    return <EUIComboBox
        {...props}
        fetchMethod={_fetchMethod}
        itemKey={item => item.idCategorieIntervenantEXTPersonne}
        itemText={item => item.categorieIntervenantEXTPersonne}
        label={label}
        placeholder={placeholder}
        stamp={stamp}
    />;

};

export default ComboBoxCategorieIntervenantEXTPersonne;